export default "__VITE_ASSET__CrtL4ma4__"